export default __webpack_public_path__ + "static/media/July2011.2730b020.png";